import { CollapsibleTooltipCell } from '@app/components/various/Table/Cells/CollapsibleTooltipCell';
import { Cms } from '@typings';

import { PreviouslyTableCell } from '../PreviouslyTableCell/PreviouslyTableCell';

interface Props {
  description: string;
  row: Cms.Page;
}

export const DescriptionCell = ({ description, row }: Props) => (
  <PreviouslyTableCell property="description" page={row}>
    <CollapsibleTooltipCell className="z-interactiveTableItem max-w-48">{description}</CollapsibleTooltipCell>
  </PreviouslyTableCell>
);
